//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../no/Section.js";
import "../Features/Features.GeometricConstraintDataManager.js";
import "../no/Features.js";
import "../no/Section.js";
let d=[[[0,"AlignAxis",1,"Axis",0],[1,"AlignCurve",0,"Section",0],[0,"AlignType",1,0],[0,"AlignVector",1,"Direction",0],[0,"EndAlignFillerSurfaceOption",1,0],[1,"Points",0,"Features.GeometricConstraintDataManager",0],[0,"StartAlignFillerSurfaceOption",1,0]],[[[],"ResetAllPoints",{},0,0],[["point"],"InsertPoint",{},1,0],[["point"],"DeletePoint",{},1,0],[[],"DeleteAllPoints",{},0,0],[["point"],"PostPointEdit",{},1,0],[["point","percentParameterOfSection"],"MovePointByPercentParameter",{},2,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.AlignmentMethodBuilder1 = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.AlignmentMethodBuilder1";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.AlignmentMethodBuilder1.Type = Object.freeze({
    "Parameter" : "Parameter", "ArcLength" : "ArcLength", "ByPoints" : "ByPoints", "Distance" : "Distance", "Angle" : "Angle", "SpineCurve" : "SpineCurve", "BySegments" : "BySegments", "Developable" : "Developable"});

SPLM.GeometricUtilities.AlignmentMethodBuilder1.FillerSurfaceType = Object.freeze({
    "NoFiller" : "NoFiller", "GeneralizedCone" : "GeneralizedCone", "GeneralizedCylinder" : "GeneralizedCylinder", "ExtrapolateAndTrim" : "ExtrapolateAndTrim"});

export default SPLM;